module.exports = __webpack_public_path__ + "static/media/oy_2.89a052cc.wav";